import { trackButtonPressed } from "../analytics/tracking";
import { AuthCard, AuthCta, AuthHeading, AuthFrame } from "./AuthShared";

/* Public terminal page for AI21 Gateway sign-ins the allowlist rejected (redirected here by authErrors.redirectIfEmailNotAllowed). Presentational, no auth hooks. */

const LANDING_URL = "https://www.ai21.com";

export function ComingSoonScreen() {
  return (
    <AuthFrame>
      <div className="onboarding onboarding-card w-full">
        <AuthCard>
          <div className="flex flex-col items-center gap-6 text-center">
            <div className="flex flex-col gap-1.5">
              <AuthHeading>Coming soon</AuthHeading>
              <p className="t-body-sm" style={{ color: "var(--fg-3)" }}>
                The AI21 Gateway is rolling out gradually and isn&apos;t open to
                your account just yet. We&apos;ll be in touch as access expands
                — check back soon.
              </p>
            </div>

            <AuthCta
              className="w-full"
              onClick={() => {
                trackButtonPressed("Learn more at ai21.com");
                window.location.assign(LANDING_URL);
              }}
            >
              Learn more at ai21.com
            </AuthCta>
          </div>
        </AuthCard>
      </div>
    </AuthFrame>
  );
}
